import script from "./ChatgtpMessage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatgtpMessage.vue?vue&type=script&setup=true&lang=ts"

import "./ChatgtpMessage.vue?vue&type=style&index=0&id=1323443b&scoped=true&lang=css"
import "./ChatgtpMessage.vue?vue&type=style&index=1&id=1323443b&lang=css"
import "./ChatgtpMessage.vue?vue&type=style&index=2&id=1323443b&lang=scss&scoped=true"
import "./ChatgtpMessage.vue?vue&type=style&index=3&id=1323443b&lang=scss"

import exportComponent from "/Users/123imac-49/Desktop/123-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1323443b"]])

export default __exports__